import { render, staticRenderFns } from "./m-dialog-base.vue?vue&type=template&id=3f942982&scoped=true&lang=pug"
import script from "./m-dialog-base.vue?vue&type=script&lang=js"
export * from "./m-dialog-base.vue?vue&type=script&lang=js"
import style0 from "./m-dialog-base.vue?vue&type=style&index=0&id=3f942982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f942982",
  null
  
)

export default component.exports